export type ComposerImage = {
  previewUrl: string;
  name: string;
  size?: number;
  file?: File;
  imageId?: string;
};

export const MAX_COMPOSER_IMAGE_BYTES = 10 * 1024 * 1024;
export const ACCEPTED_COMPOSER_IMAGE_TYPES = ["image/jpeg", "image/png", "image/gif", "image/webp"];
export const IMAGE_UPLOAD_HINT = "Upload up to 1 image. 10 MB max.";

export function composerImageFromFile(file: File): { image: ComposerImage } | { error: string } {
  if (!ACCEPTED_COMPOSER_IMAGE_TYPES.includes(file.type)) {
    return { error: "Use a JPG, PNG, GIF or WebP image." };
  }
  if (file.size > MAX_COMPOSER_IMAGE_BYTES) {
    return { error: "That image is over 10 MB — pick a smaller one." };
  }
  return { image: { previewUrl: URL.createObjectURL(file), name: file.name, size: file.size, file } };
}

export function composerImageFromStored(
  imageId: string | null | undefined,
  imageUrl: string | null | undefined,
): ComposerImage | null {
  if (!imageId || !imageUrl) return null;
  return { previewUrl: imageUrl, name: "Attached image", imageId };
}

export function releaseComposerImage(image: ComposerImage | null | undefined) {
  if (image?.file) URL.revokeObjectURL(image.previewUrl);
}

export function formatImageSize(bytes: number) {
  return bytes >= 1024 * 1024
    ? `${(bytes / 1024 / 1024).toFixed(1)} MB`
    : `${Math.max(1, Math.round(bytes / 1024))} KB`;
}
